import React, { useState } from "react";
import styles from "./PayrollTab.module.css";

const emptyForm = { period: "", baseSalary: "", commissionAmount: "", bonusAmount: "", deductionAmount: "", notes: "" };

const PayrollFormModal = ({ employee, onSubmit, onClose }) => {
  const [form, setForm] = useState({ ...emptyForm, baseSalary: employee?.baseSalary || "" });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const netSalary =
    (Number(form.baseSalary) || 0) + (Number(form.commissionAmount) || 0) +
    (Number(form.bonusAmount) || 0) - (Number(form.deductionAmount) || 0);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await onSubmit({
        ...form,
        period: new Date(form.period).toISOString(),
        baseSalary: Number(form.baseSalary) || 0,
        commissionAmount: Number(form.commissionAmount) || 0,
        bonusAmount: Number(form.bonusAmount) || 0,
        deductionAmount: Number(form.deductionAmount) || 0,
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={styles.overlay} onClick={onClose}>
      <form className={styles.modal} onClick={(e) => e.stopPropagation()} onSubmit={handleSubmit}>
        <h3>إضافة مرتب/عمولة - {employee?.fullName}</h3>

        <div className={styles.formGrid}>
          <label>الفترة (الشهر)
            <input type="month" name="period" value={form.period} onChange={handleChange} required />
          </label>
          <label>الراتب الأساسي
            <input type="number" name="baseSalary" value={form.baseSalary} onChange={handleChange} required min="0" />
          </label>
          <label>العمولة
            <input type="number" name="commissionAmount" value={form.commissionAmount} onChange={handleChange} min="0" />
          </label>
          <label>المكافأة
            <input type="number" name="bonusAmount" value={form.bonusAmount} onChange={handleChange} min="0" />
          </label>
          <label>الخصومات
            <input type="number" name="deductionAmount" value={form.deductionAmount} onChange={handleChange} min="0" />
          </label>
          <label className={styles.fullWidth}>ملاحظات
            <textarea name="notes" value={form.notes} onChange={handleChange} rows={2} />
          </label>
        </div>

        <div className={styles.netPreview}>الصافي المتوقع: <strong>{netSalary.toLocaleString()} ج.م</strong></div>

        <div className={styles.actions}>
          <button type="button" className={styles.cancelBtn} onClick={onClose} disabled={submitting}>إلغاء</button>
          <button type="submit" className={styles.confirmBtn} disabled={submitting}>
            {submitting ? "جاري الحفظ..." : "حفظ"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default PayrollFormModal;